import { useSyncExternalStore } from 'react'

/** Shows the chat on a storefront that hasn't turned it on, with or without a value. */
export const BRAND_CHAT_PARAM = 'brand-chat'

const subscribe = () => () => {}

const hasBrandChatParam = () =>
    new URLSearchParams(window.location.search).has(BRAND_CHAT_PARAM)

// False on the server, so hydration matches and the bubble appears right after.
export const useBrandChatParam = (): boolean =>
    useSyncExternalStore(subscribe, hasBrandChatParam, () => false)
